$(function () {
	$('.clock__image').each(function () {
		const cityOperator = $(this).data('zone-operator');
		const cityZone = parseInt($(this).data('zone'));
		const pcOperator = getTimezoneOffset()[0];
		const pcZone = parseInt(getTimezoneOffset().substr(1));


		let operator = '+';
		let hour = 0;

		if (cityOperator === '+' && pcOperator === '+') {
			if(cityZone > pcZone) {
				hour = cityZone - pcZone;
				operator = '+'
			} else {
				hour = pcZone - cityZone;
				operator = '-';
			}
		} else if (cityOperator === '-' && pcOperator === '+') {
			hour = cityZone + pcZone;
			operator = '-';
		} else if (cityOperator === '-' && pcOperator === '-') {
			if(cityZone > pcZone) {
				hour = cityZone - pcZone;
				operator = '+'
			} else {
				hour = pcZone - cityZone;
				operator = '-';
			}
		} else if (cityOperator === '+' && pcOperator === '-') {
			hour = cityZone + pcZone;
			operator = '+';
		}

		$(this).thooClock({
			size: 100,
			dialColor:'#000000',
			dialBackgroundColor:'transparent',
			secondHandColor:'#A50E0E',
			minuteHandColor:'#222222',
			hourHandColor:'#222222',
			alarmHandColor:'#transparent',
			alarmHandTipColor:'#transparent',
			timeCorrection: {
				operator: operator,
				hours: hour,
				minutes: 0
			},
			alarmCount: 0,
			showNumerals:false,
			sweepingMinutes:true,
			sweepingSeconds:true,
			numeralFont:'arial',
			brandFont:'arial'
		});
	});

	function getTimezoneOffset() {
		function z(n){return (n<10? '' : '') + n}
		var offset = new Date().getTimezoneOffset();
		var sign = offset < 0? '+' : '-';
		offset = Math.abs(offset);
		return sign + z(offset/60 | 0);
	}
});
